import React, { Component } from 'react';

import { postRequest, getRequest } from 'services/ApiService.js';
import { url_rest, types } from 'configuration'

import { Link } from 'react-router-dom'

import logo from 'static/img/logo-andalucia.png';

class NavPanel extends Component {

  constructor(props) {
    super(props);
    this.getTypes = this.getTypes.bind(this);
    this.navCard = this.navCard.bind(this);
    this.state = {
      types: ''
    }

    if (this.props.contentType == "recursos") {
      var data = {
        "item_number": 0,
        "page_size": 20,
        "filters": {}
      }
      data.filters["slug_" + this.props.lang] = this.props.queryTerm

      postRequest(url_rest + "/resource/paginated", data, 'multi').then(
        (response) => {
          this.setState({ result: response.data.list[0] })
        });
    }

    if (this.props.querySlug) {
      var data_slug = {
        "item_number": 0,
        "page_size": 20,
        "filters": {}
      }
      data_slug.filters["slug_" + this.props.lang] = this.props.querySlug

      postRequest(url_rest + "/resource/paginated", data_slug, 'multi').then(
        (response) => {
          this.setState({ result_slug: response.data.list[0] })
        });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps !== this.props) && this.props.queryType) {
      postRequest(url_rest + "/resource_type/paginated", {
        "item_number": 0,
        "page_size": 20,
        "filters": {
          "slug": this.props.queryType
        }
      }, this.props.lang).then(
        (response) => {
          this.setState({ result_type: response.data.list[0].code })
        });
    }
  }

  navCard(type) {
    var icon = types[type].icon;
    var label = types[type].label[this.props.lang];
    var slug = window.location.origin + '/webapp/' + this.props.lang + '/' + this.props.contentType + '/' + this.props.queryTerm + '/' + types[type].slug[this.props.lang]
    return (
      <a href={slug} className="nav-row">
        <i className={"fas " + icon + " fa-2x nav-icon-item"}></i>
        <label>{label}</label>
      </a>
    );
  }

  getTypes() {
    if (this.props.contentType == "destinos") {
      return this.getMunicipalityTypes();
    } else if (this.props.contentType == "recursos") {
      return this.getResourceTypes();
    }
  }

  getMunicipalityTypes() {
    var result = new Set();
    var dataMunicipality = {
      "item_number": 0,
      "page_size": 100,
      "filters": {
        "slug": this.props.queryTerm
      }
    };

    postRequest(url_rest + "/territory/paginated", dataMunicipality, this.props.lang).then(
      (response) => {
        //Obtenemos el ID del territorio a través de su slug
        var itemNumber = 0;
        var pageSize = 1000;
        var dataResources = {
          "filters": {
            "resources.territories.id": response.data.list[0].id
          }
        };
        
        postRequest(url_rest + "/resource_type/paginated", dataResources, this.props.lang).then(values => {
          values.data.list.map(
            element => {
              result.add(element.parent_type.code);
            });
          this.setState({ types: result });
        });
      });
  }

  getResourceTypes(term) {
    var result = new Set();
    var dataResource = {
      "item_number": 0,
      "page_size": 20,
      "filters": {
        "slug": this.props.queryTerm
      }
    };

    postRequest(url_rest + "/resource/paginated", dataResource, this.props.lang).then(
      (response) => {
        getRequest(url_rest + "/resource/get/" + response.data.list[0].id, this.props.lang).then(response => {
          postRequest(url_rest + "/resource/nearby", {
            "radius": 1000,
            "x": response.data.x_coord,
            "y": response.data.y_coord
          }, this.props.lang).then(response => {
            var promises = []
            for (let i = 0; i < response.data.list.length; i++) {
              promises.push(getRequest(url_rest + "/resource/get/" + response.data.list[i].id, this.props.lang))
            }
            Promise.all(promises).then(resouces => {
              resouces.map(resource => {
                // if (resource.data.resource_state.code == "ESTREPUBLICADO") {
                result.add(resource.data.resource_type.code)
                // }
              })
              this.setState({ types: result })
            })
          })
        })
      });
  }

  componentDidMount() {
    this.getTypes();
  }

  printLanguages() {
    var href_es = window.location.origin + "/webapp/es/" + this.props.contentType
    var href_en = window.location.origin + "/webapp/en/" + this.props.contentType
    var href_fr = window.location.origin + "/webapp/fr/" + this.props.contentType
    var href_de = window.location.origin + "/webapp/de/" + this.props.contentType

    if (this.state.result) {
      href_es += "/" + this.state.result.slug_es
      href_en += "/" + this.state.result.slug_en
      href_fr += "/" + this.state.result.slug_fr
      href_de += "/" + this.state.result.slug_de
    }

    if (this.props.contentType == "destinos") {
      href_es += '/' + this.props.queryTerm
      href_en += '/' + this.props.queryTerm
      href_fr += '/' + this.props.queryTerm
      href_de += '/' + this.props.queryTerm
    }

    if (this.state.result_type) {
      href_es += '/' + types[this.state.result_type].slug.es
      href_en += '/' + types[this.state.result_type].slug.en
      href_fr += '/' + types[this.state.result_type].slug.fr
      href_de += '/' + types[this.state.result_type].slug.de
    }

    if (this.state.result_slug) {
      href_es += '/' + this.state.result_slug.slug_es
      href_en += '/' + this.state.result_slug.slug_en
      href_fr += '/' + this.state.result_slug.slug_fr
      href_de += '/' + this.state.result_slug.slug_de
    }

    return (
      <div className="language-mb">
        <a className={this.href_active('es')} href={href_es}>ES</a>
        <a className={this.href_active('en')} href={href_en}>EN</a>
        <a className={this.href_active('fr')} href={href_fr}>FR</a>
        <a className={this.href_active('de')} href={href_de}>DE</a>
      </div>
    )
  }

  href_active(lang) {
    if (lang == this.props.lang) return "active"
  }

  render() {
    if (this.state.types != '') {
      return (
        <nav className={"nav-panel " + this.props.nav} >
          <div className="nav-header">
            <div className="logo logo-mb">
              <img src={logo} className="logo-img" />
            </div>
            <a href="#" className="icon-w60 toggle-menu-mb" onClick={this.props.clicker}><i className="fas fa-times"></i></a>
          </div>
          {this.printLanguages()}
          <div className="nav-scroll">
            {Array.from(this.state.types).map(value => this.navCard(value))}
          </div>
        </nav>
      );
    } else {
      return ("");
    }
  }
}

export default NavPanel


// WEBPACK FOOTER //
// ./src/components/NavPanel.jsx